import { createContext, useContext } from "react";
import { StoreApi } from "zustand";
import { StreamingState } from "src/reusable/Chat/ChatStreaming/stores/StreamingStore";

// Preserve context identity across Vite HMR (same pattern as ChatStreamingContext).
const getOrCreateContext = () => {
  if (import.meta.hot?.data?.chatStreamContext) {
    return import.meta.hot.data
      .chatStreamContext as React.Context<StoreApi<StreamingState> | null>;
  }
  const ctx = createContext<StoreApi<StreamingState> | null>(null);
  if (import.meta.hot?.data) {
    import.meta.hot.data.chatStreamContext = ctx;
  }
  return ctx;
};

// Per-chat context carrying the host-owned streaming store. Not exported:
// descendants reach the store only through the useChatStream hooks, whose
// view omits setStreamConfig.
const ChatStreamContext = getOrCreateContext();

/** The store the nearest ChatStreamProvider supplies, or null outside one. */
export const useProvidedChatStream = () => useContext(ChatStreamContext);

if (import.meta.hot) {
  import.meta.hot.accept();
}

export const ChatStreamProvider = ({
  store,
  children,
}: React.PropsWithChildren<{ store: StoreApi<StreamingState> }>) => (
  <ChatStreamContext.Provider value={store}>
    {children}
  </ChatStreamContext.Provider>
);
